import React, { useState, useEffect, useCallback, ReactElement } from 'react'
// @ts-ignore
import OutsideClickHandler from 'react-outside-click-handler'
import cn from 'classnames'
import s from './Dropdown.module.scss'

// Old browsers do not support 'key' property, in new - 'keyCode' is deprecated
const isKeyEvent = (
    event: { key?: string; keyCode?: number },
    keys?: string[],
    keyCodes?: number[]
): boolean => {
    if (keys && keys.length > 0 && typeof event.key !== 'undefined') {
        return keys.includes(event.key)
    }

    return (
        !!keyCodes &&
        keyCodes.length > 0 &&
        typeof event.keyCode !== 'undefined' &&
        !keyCodes.includes(event.keyCode)
    )
}

type DropdownProps = {
    startsOpen?: boolean
    openedDisplay: ReactElement
    closedDisplay: ReactElement
    className?: string
    wrapperClassName?: string
    arrow?: boolean
    onClick?: (event: MouseEvent) => unknown
    onKeyDown?: (event: KeyboardEvent) => unknown
    willOpen?: () => unknown
    willClose?: () => unknown
    css?: { [k: string]: string | number }
    preventClosingSelector?: string
}

// TODO: fix the outside clicker problem.
export const Dropdown: React.FC<DropdownProps> = (props) => {
    const { preventClosingSelector } = props

    const [open, setOpen] = useState(props.startsOpen || false)

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false)

        return () => {
            document.removeEventListener('keydown', escFunction, false)
        }
    }, [])

    const escFunction = useCallback((event) => {
        if (isKeyEvent(event, ['Escape'], [27])) {
            setOpen(false)
        }
    }, [])

    const handleClick = (event: MouseEvent) => {
        if (props.onClick) {
            props.onClick(event)
        }

        handleToggle(event.target)
    }

    const outsideClick = (e: MouseEvent) => {
        let flag = false

        if (preventClosingSelector) {
            flag = !!(e.target as Element).closest(preventClosingSelector)
        }

        if (!flag) {
            if (open && props.willClose) {
                props.willClose()
            }

            setOpen(flag)
        }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
        if (!isKeyEvent(event, ['Enter', ' '], [13, 32])) {
            return
        }

        event.preventDefault()

        if (props.onKeyDown) {
            props.onKeyDown(event)
        }

        handleToggle(event.target)
    }

    const handleToggle = (target: EventTarget | null): void => {
        let flag = false

        if (preventClosingSelector && target) {
            flag = !!(target as Element).closest(preventClosingSelector)
        }

        // If not open, then click triggers 'will open'
        if (!open && props.willOpen) {
            props.willOpen()
        }
        // If open, then click triggers 'will close'
        else if (open && props.willClose && !flag) {
            props.willClose()
        }

        setOpen(flag ? flag : !open)
    }

    // @ts-ignore
    return (
        <div
            aria-expanded={!open ? 'false' : 'true'}
            className={cn(
                props.arrow ? s['native-dropdown'] : s.dropdown,
                {
                    [s.active]: open
                },
                open ? 'drop-down-open' : '',
                props.wrapperClassName
            )}
            style={props.css}
        >
            <OutsideClickHandler onOutsideClick={outsideClick}>
                <div>
                    <span
                        // @ts-ignore
                        onClick={handleClick}
                        // @ts-ignore
                        onKeyDown={handleKeyDown}
                        role="button"
                        tabIndex={0}
                    >
                        {open ? props.openedDisplay : props.closedDisplay}
                    </span>
                    {open && (
                        <div
                            className={cn(
                                props.arrow
                                    ? s['dropdown-container']
                                    : s['dropdown-options'],
                                props.className
                            )}
                            // @ts-ignore
                            onClick={handleClick}
                            // @ts-ignore
                            onKeyDown={handleKeyDown}
                            role="button"
                            tabIndex={0}
                        >
                            {props.children}
                        </div>
                    )}
                </div>
            </OutsideClickHandler>
        </div>
    )
}
